import { inject, Injectable, Type } from '@angular/core';
import {
  AutomationActionType,
  IAutomationAction,
} from '@kinet-open-network/shared/data-access/model';
import { AUTOMATION_BUILDER_CONFIG } from '../automation-builder.config';
import { generateAutomationId } from '../automation-id-generator.util';
import ACTION_MAP from './actions';
import { ActionComponent } from './actions/abstract-action.component';

@Injectable()
export class AutomationActionService {
  readonly #config = inject(AUTOMATION_BUILDER_CONFIG, { optional: true });

  createAction<T extends AutomationActionType>(
    type?: T,
  ): Partial<IAutomationAction<T>> {
    return {
      id: this.generateId(),
      collapsed: false,
      type,
      data: {},
    };
  }

  generateId(): string {
    return generateAutomationId();
  }

  getComponentForType<T extends AutomationActionType>(
    type?: T,
  ): Type<ActionComponent<T>> {
    if (!type) {
      return ActionComponent;
    }
    const merged = { ...ACTION_MAP, ...this.#config?.actions };
    return (merged[type] ?? ActionComponent) as Type<ActionComponent<T>>;
  }
}
